import { useEffect, useState } from 'react';

export function useTimestamp() {
  const [timestamp1, setTimestamp1] = useState(+global.localStorage.getItem('timestamp1'));
  const [timestamp2, setTimestamp2] = useState(+global.localStorage.getItem('timestamp2'));
  const [timestamp3, setTimestamp3] = useState(+global.localStorage.getItem('timestamp3'));

  useEffect(() => {
    window.addEventListener('storage', () => {
      setTimestamp1(+global.localStorage.getItem('timestamp1'));
      setTimestamp2(+global.localStorage.getItem('timestamp2'));
      setTimestamp3(+global.localStorage.getItem('timestamp3'));
    });

    return () => {
      window.removeEventListener('storage', () => {
        setTimestamp1(+global.localStorage.getItem('timestamp1'));
        setTimestamp2(+global.localStorage.getItem('timestamp2'));
        setTimestamp3(+global.localStorage.getItem('timestamp3'));
      });
    };
  }, []);

  return { timestamp1, timestamp2, timestamp3 };
}

export default useTimestamp;
